export const strings = {
  title: 'إدارة الاختبارات',
  subtitle: 'اختبار لكل مقرر، وقواعد اختيار أسئلته',
  create: 'اختبار جديد',
  close: 'إغلاق',
  save: 'حفظ',
  saved: 'تم الحفظ بنجاح',
  deleted: 'تم الحذف بنجاح',
  actionFailed: 'تعذر إتمام العملية',
  deleteConfirm: 'هل أنت متأكد من حذف هذا الاختبار؟',
  allCoursesHaveExam: 'كل المقررات لديها اختبار بالفعل',

  columns: {
    index: 'م',
    course: 'المقرر',
    name: 'اسم الاختبار',
  },

  row: {
    edit: 'تعديل',
    delete: 'حذف',
  },

  form: {
    editTitle: 'تعديل الاختبار',
    createTitle: 'اختبار جديد',
    course: 'المقرر',
    nameAr: 'الاسم بالعربية',
    nameEn: 'الاسم بالإنجليزية',
    passLimit: 'درجة النجاح',
    tries: 'عدد المحاولات',
    forceWatch: 'إلزام بمشاهدة المحتوى',
    hideAnswers: 'إخفاء الإجابات',
    preventIfSucceeded: 'منع إعادة الاختبار بعد النجاح',
    rewatch: 'نسبة إعادة المشاهدة عند الرسوب',
    required: 'هذا الحقل مطلوب',
  },

  rules: {
    title: 'قواعد اختيار الأسئلة',
    hint: 'كل قاعدة تحدد عدد الأسئلة المأخوذة من موضوع بمستوى صعوبة معين',
    topic: 'الموضوع',
    level: 'مستوى الصعوبة',
    count: 'عدد الأسئلة',
    available: 'المتاح',
    add: 'إضافة قاعدة',
    remove: 'حذف',
    empty: 'لم تُضف أي قاعدة بعد',
    tooMany: 'العدد المطلوب أكبر من عدد الأسئلة المتاحة',
  },
}
